module.exports = __webpack_public_path__ + "media/images/www/contact_phone_dark_teal-97fce0229c41b953981e2974b337ebcf.svg";